// =============================================================================
// GOUVERNANCE - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Le rendu historique (_GouvDashboardLegacy.jsx) a été retiré (D-140) ; il
// reste dans l'historique git. Le contenu est extrait en 5 widgets dans
// frontend/src/widgets/governance/, catalogués côté serveur et résolus
// via la cascade dashboard_layouts.
// =============================================================================
import DashboardGrid from "../../../components/dashboard/DashboardGrid";

export default function GouvDashboard() {
  return (
    <DashboardGrid hub="governance" title="Dashboard Gouvernance" />
  );
}
